var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeaDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7164_15550)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.686035 24.2409C0.686035 23.2744 1.46954 22.4909 2.43604 22.4909H44.436C45.4025 22.4909 46.186 23.2744 46.186 24.2409C46.186 31.5897 44.3748 38.412 40.5837 43.4432C36.7482 48.5331 30.9775 51.6576 23.436 51.6576C15.8946 51.6576 10.1238 48.5331 6.28841 43.4432C2.49723 38.412 0.686035 31.5897 0.686035 24.2409ZM4.22372 25.9909C4.4891 32.0928 6.15199 37.4463 9.08366 41.3369C12.2482 45.5365 16.9775 48.1576 23.436 48.1576C29.8946 48.1576 34.6238 45.5365 37.7884 41.3369C40.7201 37.4463 42.383 32.0928 42.6483 25.9909H4.22372Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.436 6.15759C24.4025 6.15759 25.186 6.94109 25.186 7.90759V17.2409C25.186 18.2074 24.4025 18.9909 23.436 18.9909C22.4695 18.9909 21.686 18.2074 21.686 17.2409V7.90759C21.686 6.94109 22.4695 6.15759 23.436 6.15759Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1027 10.8243C36.0692 10.8243 36.8527 11.6078 36.8527 12.5743V17.2409C36.8527 18.2074 36.0692 18.9909 35.1027 18.9909C34.1362 18.9909 33.3527 18.2074 33.3527 17.2409V12.5743C33.3527 11.6078 34.1362 10.8243 35.1027 10.8243Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7694 10.8243C12.7359 10.8243 13.5194 11.6078 13.5194 12.5743V17.2409C13.5194 18.2074 12.7359 18.9909 11.7694 18.9909C10.8029 18.9909 10.0194 18.2074 10.0194 17.2409V12.5743C10.0194 11.6078 10.8029 10.8243 11.7694 10.8243Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9921 28.331C45.7572 30.7557 45.3078 33.0889 44.638 35.2822C44.9521 35.3098 45.2741 35.3243 45.6027 35.3243C47.5731 35.3243 49.2754 34.8075 50.4311 34.0645C51.6056 33.3095 52.0194 32.4767 52.0194 31.8243C52.0194 31.1718 51.6056 30.339 50.4311 29.584C49.3522 28.8904 47.7971 28.394 45.9921 28.331ZM44.198 24.8922C44.6576 24.8473 45.1266 24.8243 45.6027 24.8243C48.1427 24.8243 50.5238 25.4827 52.3238 26.6399C54.1051 27.785 55.5194 29.5772 55.5194 31.8243C55.5194 34.0713 54.1051 35.8635 52.3238 37.0086C50.5238 38.1658 48.1427 38.8243 45.6027 38.8243C44.2814 38.8243 43.0127 38.6465 41.8499 38.3186C41.3766 38.1852 40.9813 37.8587 40.7607 37.4192C40.5402 36.9796 40.5148 36.4675 40.6907 36.0083C41.7721 33.1852 42.4225 29.9806 42.6209 26.5333C42.6705 25.6724 43.3398 24.976 44.198 24.8922Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7164_15550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    transform: "translate(0.102051 0.907715)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeaDrink);
export default __webpack_public_path__ + "static/media/tea-drink.a41c7296.svg";
export { ForwardRef as ReactComponent };